import { render, staticRenderFns } from "./MultipleForm.vue?vue&type=template&id=67e04b86&scoped=true"
import script from "./MultipleForm.vue?vue&type=script&lang=js"
export * from "./MultipleForm.vue?vue&type=script&lang=js"
import style0 from "./MultipleForm.vue?vue&type=style&index=0&id=67e04b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e04b86",
  null
  
)

export default component.exports